var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-menu"},[_c('button',{staticClass:"btn btn--close",on:{"click":function($event){return _vm.toggleMobileMenu()}}},[_c('i',{staticClass:"btn__icn las la-times"})]),_c('Navigation',{attrs:{"layout":'mobile'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }